/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_DoneInputs */

const en_tourhelp_done = /** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const ar_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const he_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const ur_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const es_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const fr_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const de_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const pt_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const hi_tourhelp_done = en_tourhelp_done;

/** @type {(inputs: Tourhelp_DoneInputs) => LocalizedString} */
const bn_tourhelp_done = en_tourhelp_done;

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Tourhelp_DoneInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_done = /** @type {((inputs?: Tourhelp_DoneInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_DoneInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_done(inputs)
	if (locale === "he") return he_tourhelp_done(inputs)
	if (locale === "ur") return ur_tourhelp_done(inputs)
	if (locale === "es") return es_tourhelp_done(inputs)
	if (locale === "fr") return fr_tourhelp_done(inputs)
	if (locale === "de") return de_tourhelp_done(inputs)
	if (locale === "pt") return pt_tourhelp_done(inputs)
	if (locale === "hi") return hi_tourhelp_done(inputs)
	if (locale === "bn") return bn_tourhelp_done(inputs)
	return /** @type {LocalizedString} */ ("Done")
});